var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Card from '../../../components/Card/Card.vue';
import LineGraph from '../../../components/Graphs/LineGraph.vue';
import { sortBy, upperFirst } from 'lodash';
import rpc from '../../../api/rpc';
import getDisplayValue from '../../../components/GenericTable/utils/getDisplayValue';
import fullScreenLoading from '../../../utils/fullScreenLoading';
import getSessionContext from 'src/utils/context/getSessionContext';
export default Vue.extend({
    components: { Card, LineGraph },
    props: {
        row: { type: Object, default: null, required: true },
        col: { type: Object, default: null, required: true },
        isNetworkView: { type: Boolean, default: false }
    },
    data() {
        return {
            visible: false,
            historyData: [],
            selectedResSources: ['Any'],
            selectedTimeOfWeekAggregates: ['Any', 'Peak', 'Off peak'],
            atHomeStudiosIncluded: true
        };
    },
    computed: {
        displayValue() { return getDisplayValue(this['col'], this['row']); },
        studioMetrics() { return sortBy(this.$store.state['ci.studio_metrics'].list, 'display_order'); },
        metricsToShow() {
            return this.studioMetrics.filter(r => this.selectedResSources.includes(String(r.source_of_res_cut)) &&
                this.selectedTimeOfWeekAggregates.includes(String(r.peak_or_offpeak_cut)));
        },
        studio_metric_ids_data() {
            return this.metricsToShow.map(r => Number(r.id));
        },
        dataZoomProp() {
            return [{
                    type: 'inside',
                    start: 90,
                    end: 100
                }, {
                    start: 0,
                    end: 10,
                    handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '70%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2
                    },
                    textStyle: {
                        fontSize: 10
                    }
                }];
        },
        optionsToDeepmergeIntoGraph() {
            return {
                grid: { top: '30px', left: '50px', right: '500px', bottom: '70px' },
                legend: { top: '30px' },
                toolbox: { right: '500px' },
                tooltip: {
                    formatter: (params) => {
                        const series = params;
                        let res = `
            <div id="tooltip-container">`;
                        res += `
              <div style="padding-bottom:6px"><span style="font-size:18px;font-weight:600">${(new Intl.DateTimeFormat(undefined, {})).format(Date.parse(series[0].name + 'T00:00:00'))}</span></div>
              <table>
                <tr>
                  <th style="font-weight:500;padding-bottom:5px">Metric</th>
                  <th style="font-weight:500;padding-bottom:5px">Value</th>
                </tr>
              `;
                        for (const serie of series) {
                            res += `
                <tr style="height:25px">
                  <td><span style="padding-right:10px">${upperFirst(serie.seriesName)}</span></td>
                  <td>${(new Intl.NumberFormat(undefined, (this.metricsToShow[serie.seriesIndex] || {}).tooltip_number_format_option || undefined)).format(serie.value || 0)}<td>
                </tr>`;
                        }
                        res += `
              </table>
            </div>`;
                        return res;
                    }
                }
            };
        },
        sortedHistoryData() {
            if (this.studio_metric_ids_data === null)
                return [];
            const res = sortBy(this.historyData, ['display_order']).filter(r => this.studio_metric_ids_data && this.studio_metric_ids_data.includes(Number(r.metric_id)));
            return res;
        }
    },
    watch: {
        isNetworkView: {
            immediate: true,
            handler(newVal) {
                if (newVal === true) {
                    this.visible = true;
                    this.fetchHistoryData();
                }
            }
        },
        atHomeStudiosIncluded() { this.fetchHistoryData(); },
        col: {
            immediate: false,
            handler(newVal) {
                this.selectedResSources = [newVal.metricObject.source_of_res_cut];
                this.selectedTimeOfWeekAggregates = [newVal.metricObject.peak_or_offpeak_cut];
            }
        },
        visible: {
            immediate: false,
            handler(newVal) {
                if (newVal === false && this.isNetworkView === true) {
                    this.$destroy();
                    window.history.back();
                }
            }
        }
    },
    methods: {
        getDisplayValue() { return getDisplayValue; },
        handleClick() {
            return __awaiter(this, void 0, void 0, function* () {
                this.visible = true;
                this.fetchHistoryData();
            });
        },
        fetchHistoryData() {
            return __awaiter(this, void 0, void 0, function* () {
                let studioId = this.row.id;
                const tenantId = getSessionContext().tenant_id;
                if (this.isNetworkView) {
                    if (tenantId === 422) {
                        if (this.atHomeStudiosIncluded)
                            studioId = 422;
                        if (!this.atHomeStudiosIncluded)
                            studioId = 737;
                    }
                    else if (tenantId === 895) {
                        studioId = 895;
                    }
                }
                const payload = {
                    api_version: 1,
                    action: 'select',
                    entity: `ci.studio_metric_history_fetch`,
                    action_arguments: [
                        { argument_number: 1, value: studioId, type: 'int4' }
                    ]
                };
                fullScreenLoading.show({ message: 'Fetching studio metrics history data' });
                rpc('generic_controllers.rpc', payload).then((response) => {
                    if (response && response.data)
                        this.historyData = response.data;
                    fullScreenLoading.hide();
                });
            });
        }
    }
});
